import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { addMonths, format } from 'date-fns';
import { PreviousJobs } from 'server/shared/collections/previousJobs';
import { Organisation } from 'server/shared/models/organisation';
import { PreviousJobsDepartmentJob } from 'server/shared/models/previousJob';
import { PoolerUser } from 'server/shared/models/user';
import { dbDayDateToken } from 'server/static/dbDayDateToken';
import { OrganisationService } from '../../services/organisation.service';

interface PreviousJobForLogSheet extends PreviousJobsDepartmentJob {
  department: {
    id: string;
    displayName: string;
  };
}
@Component({
  selector: 'previous-jobs-log-sheet',
  templateUrl: 'previous-jobs-log-sheet.html',
  styleUrls: ['previous-jobs-log-sheet.scss'],
})
export class PreviousJobsLogSheetComponent implements OnInit, OnDestroy {
  organisation?: Organisation;
  departmentName: string = '';

  recentJobs: PreviousJobForLogSheet[] = [];
  oldJobs: PreviousJobForLogSheet[] = [];

  countInOrganisation: number = 0;
  countInDepartment: number = 0;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      user?: PoolerUser;
      email?: string;
      name?: string;
      departmentId: string;
    },
    private ngZone: NgZone,
    private organisationService: OrganisationService,
  ) {}

  isLoading = true;

  async ngOnInit() {
    const organisationAndDepartment =
      await this.organisationService.getOrganisationAndDepartmentById(
        this.data.departmentId,
      );
    if (!organisationAndDepartment) return;
    const { organisation, department } = organisationAndDepartment;
    this.organisation = organisation;
    this.isLoading = false;
    Tracker.autorun(() => {
      if (!this.data.departmentId) return;

      this.departmentName = department?.name || '';
      const previousJobsOfUser = PreviousJobs.findOne({
        $or: [
          {
            email: this.data?.email || '',
            fullName: this.data?.name || '',
          },
          {
            userId: this.data?.user?._id || '',
          },
        ],
        [`organisations.departments.id`]: this.data.departmentId,
      });
      if (!previousJobsOfUser) return;

      let previousJobOrganisation = previousJobsOfUser.organisations.find(
        (organisation) =>
          organisation.departments.some(
            (department) => department.id === this.data.departmentId,
          ),
      );

      let allRelevantJobs: PreviousJobForLogSheet[] = [];

      previousJobOrganisation?.departments?.forEach((department) => {
        allRelevantJobs = [
          ...allRelevantJobs,
          ...department.jobs.map((j) => ({
            ...j,
            department: {
              id: department.id,
              displayName: department.displayName || '',
            },
          })),
        ];
      });

      allRelevantJobs.forEach((j) => {
        if (j.date > format(addMonths(new Date(), -3), dbDayDateToken)) {
          this.recentJobs.push(j);
        } else {
          this.oldJobs.push(j);
        }
      });
      this.countInOrganisation = this.recentJobs.length;
      this.countInDepartment = this.recentJobs.filter(
        (j) => j.department.id === this.data.departmentId,
      ).length;
    });
  }

  ngOnDestroy() {}
}
